export enum UpgradeReportType {
    SETTINGS = 'SETTINGS',
    AKK = 'AKK',
    NOAKK = 'NOAKK',
    ASCAD = 'ASCAD',
    TUNES = 'TUNES',
    TUNES_DEBITS = 'TUNES_DEBITS',
    QUALIFICATIONS = 'QUALIFICATIONS',
    REWARDS = 'REWARDS',
    LINKED_ACCOUNTS = 'LINKED_ACCOUNTS'
}

export class ReportTypeIdUtil {
  public static fromS3Key(s3Key:String):UpgradeReportType {
    if (s3Key.endsWith('-settings_report.xlsx')) { return UpgradeReportType.SETTINGS; }
    if (s3Key.endsWith('Gen2KrpAKK_NoMapping.txt')) { return UpgradeReportType.NOAKK; }
    if (s3Key.endsWith('akk_mapping.txt')) { return UpgradeReportType.AKK; }
    if (s3Key.endsWith('ocad_export.txt')) { return UpgradeReportType.ASCAD; }
    if (s3Key.endsWith('tunes_grant_export.txt')) { return UpgradeReportType.TUNES; }
    if (s3Key.endsWith('tunes_grant_debits_export.txt')) { return UpgradeReportType.TUNES_DEBITS; }
    if (s3Key.endsWith('-AccountQualReport.xlsx')) { return UpgradeReportType.QUALIFICATIONS; }
    if (s3Key.endsWith('-AccountRewardReport.xlsx')) { return UpgradeReportType.REWARDS; }
    return UpgradeReportType.LINKED_ACCOUNTS;
  }
}
